import { useSelector } from "react-redux";
import { IState } from "../interfaces/FormData";
import { getObjectKeyData } from "./helpers";

function useGetFormData<IReturn>({
    key,
}: {
    key: string; // dot separated list
}): IReturn {
    // hooks
    const data = useSelector((state: IState) =>
        getObjectKeyData({ dataObj: state.formData, key })
    );

    return data;
}

export default useGetFormData;
